import React from "react";
import NativeShare from "./NativeShare";
import DownloadBtnCommon from "./DownloadBtn";

export default class SharePrintIcon extends React.Component {
  render() {
    const { image, text, id } = this.props;
    return (
      <div className="mantra_sharelist1">
        <ul>
          <li>
            {
              <NativeShare
                sharedata={{
                  image,
                  text,
                  postid: id ? id : "",
                }}
              >
                <img src="/assets/img/share.png" className="img-fluid" alt="" />
              </NativeShare>
            }
          </li>
          <li>
            <DownloadBtnCommon pageData={this.props.pageData} module={id}>
              <img src="/assets/img/print.png" className="img-fluid" alt="" />
            </DownloadBtnCommon>
          </li>
        </ul>
      </div>
    );
  }
}
